import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrustpilotWidgetComponent } from './trustpilot-widget.component';

@NgModule({
  declarations: [TrustpilotWidgetComponent],
  imports: [CommonModule],
  exports: [TrustpilotWidgetComponent],
})
export class TrustpilotWidgetModule {}
